import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import useForgotPassword from "../../../services/useForgotPassword";
import { ButtonLoader1 } from "../../../components/shared/ButtonLoaders";
import { Link, useNavigate } from "react-router-dom";
import PasswordResetModal from "../../../components/ForgotPasswordModal";

const validationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Email is required")
    .max(100, "Limit exceeded"),
});

function ForgotPassword() {
  const { ForgotPassword: requestForgotPassword, loading } =
    useForgotPassword();
  const [showModal, setShowModal] = useState(false);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: { email: "" },
      validationSchema,
      onSubmit: async (vals) => {
        try {
          const res = await requestForgotPassword({ email: vals.email.trim() });
          if (res?.token) {
            setToken(res.token);
          }
          setShowModal(true);
        } catch (_) {}
      },
    });

  return (
    <>
      <div className="py-5 w-full min-h-[100vh]">
        <div className="flex justify-between items-center px-12">
          <Link
            to="/"
            className="flex items-center gap-1 mb-2 font-extrabold text-[24px]"
          >
            <img src="/assets/logo/logo.svg" alt="MedTag logo" />
            <h1 className="text-[#175635]">MedTag</h1>
          </Link>
          <Link to="/contact" className="text-primary">
            Contact
          </Link>
        </div>

        <div className="flex justify-center mt-32">
          <div className="flex flex-col justify-center items-center w-full md:w-[500px]">
            <form onSubmit={handleSubmit} noValidate className="w-full">
              <p className="font-[700] text-[30px] text-primary text-center">
                Forgot Password
              </p>
              <h1 className="font-[600] text-[#333] text-[20px] text-center">
                Let’s get you back in
              </h1>
              <p className="font-[500] text-[#202224] text-[15px] text-center">
                We'll send a code to your email address to set up your new
                password.
              </p>

              <div className="flex flex-col gap-3 mt-4 w-full">
                <div>
                  <label
                    htmlFor="email"
                    className="font-normal text-[#0B4F2C] text-[14px]"
                  >
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="bg-[#EFEFF4] px-3 border border-[#DEE4ED] hover:border-primary focus:border-primary rounded-[10px] outline-none w-full h-[40px]"
                  />
                  {errors.email && touched.email && (
                    <p className="mt-1 text-red-700 text-xs">{errors.email}</p>
                  )}
                </div>
              </div>

              <button
                className="flex justify-center items-center bg-primary hover:opacity-80 mt-6 rounded-[10px] w-full h-[40px] text-white"
                type="submit"
                disabled={loading}
              >
                {loading ? <ButtonLoader1 /> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {showModal && (
        <PasswordResetModal
          email={values.email}
          onContinue={() => {
            setShowModal(false);
            navigate(
              `/`
            );
          }}
        />
      )}
    </>
  );
}

export default ForgotPassword;
